import { Location } from '@hakimo-ui/hakimo/types';
import { Page } from '@hakimo-ui/hakimo/ui-layout';
import { Tabs } from '@hakimo-ui/shared/ui-base';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FaceRecognition from './face-recognition/FaceRecognition';
import { Floorplan } from './floorplan/Floorplan';
import { PointOfContact } from './location-contacts/PointOfContact';
import LocationDetailsHeader from './location-details-header/LocationDetailsHeader';
import SiteMonitorSchedule from './site-monitoring-schedule/SiteMonitorSchedule';
import SOPRoot from './sop/SOPRoot';
import { getTabFromParam, LocationDetailsTabs, viewItems } from './util';

interface Props {
  location: Location;
}

function LocationDetails(props: Props) {
  const { location } = props;

  const [searchParams] = useSearchParams();
  const [activeViewId, setActiveViewId] = useState<LocationDetailsTabs>(
    getTabFromParam(searchParams.get('tab')) ?? viewItems[0].id
  );
  const onChangeTab = (tabId: LocationDetailsTabs) => setActiveViewId(tabId);
  const navigate = useNavigate();
  const onClickBack = () => {
    navigate('/locations');
  };

  return (
    <Page
      title={location.name}
      subtitle="Location Details"
      onClickBack={onClickBack}
    >
      <div className="bg-onlight-bg-1 dark:bg-ondark-bg-1 px-4">
        <LocationDetailsHeader location={location} />
        <Tabs
          items={viewItems}
          activeTabId={activeViewId}
          onChange={onChangeTab}
        />
        <div className="py-6">
          {activeViewId === LocationDetailsTabs.FLOOR_PLAN && (
            <Floorplan location={location} />
          )}
          {activeViewId === LocationDetailsTabs.SOP && (
            <SOPRoot
              locationId={location.id.toString()}
              tenantId={location.tenant_id ?? ''}
              timezone={location.timezone}
            />
          )}
          {activeViewId === LocationDetailsTabs.SITE_MONITORING_SCHEDULE && (
            <SiteMonitorSchedule location={location} />
          )}
          {activeViewId === LocationDetailsTabs.LOCATION_CONTACTS && (
            <PointOfContact
              locationId={location.id}
              tenantId={location.tenant_id || ''}
            />
          )}
          {activeViewId === LocationDetailsTabs.FACE_RECOGNITION && (
            <FaceRecognition
              locationId={location.id}
              tenantId={location.tenant_id || ''}
            />
          )}
        </div>
      </div>
    </Page>
  );
}

export default LocationDetails;
